import React from "react";
import "./descriptionInicio.css";

function Description() {
  return (
    <div id="descriptionInicio">
      <h1 className="descriptionInicio">
        <span className="line-1">El poder innovador de la generación </span>
        <br />
        <br/>
        <span className="line-2">
          La generación de nosotros,<br />
          <br/> la generación de Internet
        </span>
      </h1>
    </div>
  );
}

export default Description;
